import SineIcon from "../../../shared-assets/icons/dataflow/generator/sine.svg";
import SquareIcon from "../../../shared-assets/icons/dataflow/generator/square.svg";
import TriangleIcon from "../../../shared-assets/icons/dataflow/generator/triangle.svg";
import AndIcon from "../../../shared-assets/icons/dataflow/logic/and.svg";
import EqualIcon from "../../../shared-assets/icons/dataflow/logic/equal.svg";
import GreaterThanOrEqualToIcon from "../../../shared-assets/icons/dataflow/logic/greater-than-or-equal-to.svg";
import GreaterThanIcon from "../../../shared-assets/icons/dataflow/logic/greater-than.svg";
import LessThanOrEqualToIcon from "../../../shared-assets/icons/dataflow/logic/less-than-or-equal-to.svg";
import LessThanIcon from "../../../shared-assets/icons/dataflow/logic/less-than.svg";
import NandIcon from "../../../shared-assets/icons/dataflow/logic/nand.svg";
import NotEqualIcon from "../../../shared-assets/icons/dataflow/logic/not-equal.svg";
import OrIcon from "../../../shared-assets/icons/dataflow/logic/or.svg";
import XorIcon from "../../../shared-assets/icons/dataflow/logic/xor.svg";
import AddIcon from "../../../shared-assets/icons/dataflow/math/add.svg";
import SubtractIcon from "../../../shared-assets/icons/dataflow/math/subtract.svg";
import MultiplyIcon from "../../../shared-assets/icons/dataflow/math/multiply.svg";
import DivideIcon from "../../../shared-assets/icons/dataflow/math/divide.svg";
import LightBulbIcon from "../../../shared-assets/icons/dataflow/output/light-bulb.svg";
import GrabberIcon from "../../../shared-assets/icons/dataflow/output/grabber.svg";
import AdvancedGrabberIcon from "../../assets/icons/output/advanced-grabber.svg";
import HumidIcon from "../../../shared-assets/icons/dataflow/output/humid.svg";
import FanIcon from "../../../shared-assets/icons/dataflow/output/fan.svg";
import TemperatureIcon from "../../../shared-assets/icons/dataflow/sensor/temperature.svg";
import CO2Icon from "../../../shared-assets/icons/dataflow/sensor/co2.svg";
import HumidityIcon from "../../../shared-assets/icons/dataflow/sensor/humidity.svg";
import LightIcon from "../../../shared-assets/icons/dataflow/sensor/light.svg";
import SignalIcon from "../../../shared-assets/icons/dataflow/control/signal.svg";
import EMGIcon from "../../../shared-assets/icons/dataflow/sensor/sensor-emg-icon.svg";
import PressureIcon from "../../../shared-assets/icons/dataflow/sensor/pressure.svg";
import ServoIcon from "../../../shared-assets/icons/dataflow/output/servo.svg";
import AbsoluteValueIcon from "../../../shared-assets/icons/dataflow/transform/absolute-value.svg";
import NegationIcon from "../../../shared-assets/icons/dataflow/transform/negation.svg";
import NotIcon from "../../../shared-assets/icons/dataflow/transform/not.svg";
import HoldPreviousArrowIcon from "../../assets/icons/control/hold-previous.svg";
import HoldCurrentArrowIcon from "../../assets/icons/control/hold-this.svg";
import HoldZeroArrowIcon from "../../assets/icons/control/hold-zero.svg";
import { isFiniteNumber } from "../../../../utilities/math-utils";
import { deviceSupportsOutput } from "./device-capabilities";
export const kMaxNodeValues = 16;
export const NodeTypes = [
    {
        name: "Sensor",
        displayName: "Input",
    },
    {
        name: "Number",
        displayName: "Number",
    },
    {
        name: "Generator",
        displayName: "Generator",
    },
    {
        name: "Timer",
        displayName: "Timer (on/off)"
    },
    {
        name: "Math",
        displayName: "Math",
    },
    {
        name: "Logic",
        displayName: "Logic",
    },
    {
        name: "Transform",
        displayName: "Transform",
    },
    {
        name: "Control",
        displayName: "Hold",
    },
    {
        name: "Demo Output",
        displayName: "Demo Output",
    },
    {
        name: "Live Output",
        displayName: "Live Output",
    }
];
export const NodeOperationTypes = [
    {
        name: "Add",
        type: "math",
        method: (n1, n2) => n1 + n2,
        numberSentence: (n1, n2) => `${n1} + ${n2} = `,
        icon: AddIcon
    },
    {
        name: "Subtract",
        type: "math",
        method: (n1, n2) => n1 - n2,
        numberSentence: (n1, n2) => `${n1} - ${n2} = `,
        icon: SubtractIcon
    },
    {
        name: "Multiply",
        type: "math",
        method: (n1, n2) => n1 * n2,
        numberSentence: (n1, n2) => `${n1} * ${n2} = `,
        icon: MultiplyIcon
    },
    {
        name: "Divide",
        type: "math",
        method: (n1, n2) => n1 / n2,
        numberSentence: (n1, n2) => `${n1} / ${n2} = `,
        icon: DivideIcon
    },
    {
        name: "Absolute Value",
        type: "transform",
        method: (n1, n2) => Math.abs(n1),
        numberSentence: (n1, n2) => `|${n1}| = `,
        icon: AbsoluteValueIcon
    },
    {
        name: "Negation",
        type: "transform",
        method: (n1, n2) => 0 - n1,
        numberSentence: (n1, n2) => `-(${n1}) = `,
        icon: NegationIcon
    },
    {
        name: "Not",
        type: "transform",
        method: (n1, n2) => n1 ? 0 : 1,
        numberSentence: (n1, n2) => `!${n1} ⇒ `,
        icon: NotIcon
    },
    {
        name: "Round",
        type: "transform",
        method: (n1, n2) => Math.round(n1),
        numberSentence: (n1, n2) => `round(${n1}) = `,
        icon: SignalIcon
    },
    {
        name: "Floor",
        type: "transform",
        method: (n1, n2) => Math.floor(n1),
        numberSentence: (n1, n2) => `floor(${n1}) = `,
        icon: SignalIcon
    },
    {
        name: "Ceil",
        type: "transform",
        method: (n1, n2) => Math.ceil(n1),
        numberSentence: (n1, n2) => `ceil(${n1}) = `,
        icon: SignalIcon
    },
    {
        name: "Ramp",
        type: "transform",
        method: (n1, n2, prevValue) => {
            if (!isFiniteNumber(prevValue))
                return n1;
            const delta = n1 - prevValue;
            const isSteep = Math.abs(delta) > 0.1 * prevValue;
            if (delta > 0) {
                const increaseBy = n1 * 0.1;
                return isSteep ? prevValue + increaseBy : n1;
            }
            if (delta < 0) {
                const decreaseBy = prevValue * 0.1;
                return isSteep ? prevValue - decreaseBy : n1;
            }
            return n1;
        },
        numberSentence: (n1, n2) => `${n1} → `,
        icon: SignalIcon
    },
    {
        name: "Greater Than",
        type: "logic",
        method: (n1, n2) => +(n1 > n2),
        numberSentence: (n1, n2) => `${n1} > ${n2} ⇒ `,
        icon: GreaterThanIcon
    },
    {
        name: "Less Than",
        type: "logic",
        method: (n1, n2) => +(n1 < n2),
        numberSentence: (n1, n2) => `${n1} < ${n2} ⇒ `,
        icon: LessThanIcon
    },
    {
        name: "Greater Than Or Equal To",
        type: "logic",
        method: (n1, n2) => +(n1 >= n2),
        numberSentence: (n1, n2) => `${n1} >= ${n2} ⇒ `,
        icon: GreaterThanOrEqualToIcon
    },
    {
        name: "Less Than Or Equal To",
        type: "logic",
        method: (n1, n2) => +(n1 <= n2),
        numberSentence: (n1, n2) => `${n1} <= ${n2} ⇒ `,
        icon: LessThanOrEqualToIcon
    },
    {
        name: "Equal",
        type: "logic",
        method: (n1, n2) => +(n1 === n2),
        numberSentence: (n1, n2) => `${n1} == ${n2} ⇒ `,
        icon: EqualIcon
    },
    {
        name: "Not Equal",
        type: "logic",
        method: (n1, n2) => +(n1 !== n2),
        numberSentence: (n1, n2) => `${n1} != ${n2} ⇒ `,
        icon: NotEqualIcon
    },
    {
        name: "And",
        type: "logic",
        method: (n1, n2) => n1 && n2 ? 1 : 0,
        numberSentence: (n1, n2) => `${n1} && ${n2} ⇒ `,
        icon: AndIcon
    },
    {
        name: "Or",
        type: "logic",
        method: (n1, n2) => n1 || n2 ? 1 : 0,
        numberSentence: (n1, n2) => `${n1} || ${n2} ⇒ `,
        icon: OrIcon
    },
    {
        name: "Nand",
        type: "logic",
        method: (n1, n2) => +(!(n1 && n2 ? 1 : 0)),
        numberSentence: (n1, n2) => `${n1} nand ${n2} ⇒ `,
        icon: NandIcon
    },
    {
        name: "Xor",
        type: "logic",
        method: (n1, n2) => +((n1 ? 1 : 0) !== (n2 ? 1 : 0)),
        numberSentence: (n1, n2) => `${n1} xor ${n2} ⇒ `,
        icon: XorIcon
    }
];
export const HoldFunctionOptions = [
    {
        name: "Hold Current",
        displayName: "Hold this",
        type: "control",
        icon: HoldCurrentArrowIcon
    },
    {
        name: "Hold Prior",
        displayName: "Hold previous",
        type: "control",
        icon: HoldPreviousArrowIcon
    },
    {
        name: "Output Zero",
        displayName: "Hold 0",
        type: "control",
        icon: HoldZeroArrowIcon
    },
    // {
    //   name: "Hold Current Wait",
    //   displayName: "Hold this, wait",
    //   type: "control",
    //   icon: HoldCurrentArrowIcon
    // },
    // {
    //   name: "Hold Prior Wait",
    //   displayName: "Hold previous, wait",
    //   type: "control",
    //   icon: HoldPreviousArrowIcon
    // },
    // {
    //   name: "Output Zero Wait",
    //   displayName: "Hold 0, wait",
    //   type: "control",
    //   icon: HoldZeroArrowIcon
    // }
];
export const NodeSensorTypes = [
    {
        name: "Temperature",
        type: "temperature",
        units: "°C",
        icon: TemperatureIcon
    },
    {
        name: "Humidity",
        type: "humidity",
        units: "%",
        icon: HumidityIcon
    },
    {
        name: "CO₂",
        type: "CO2",
        units: "PPM",
        icon: CO2Icon
    },
    {
        name: "Light",
        type: "light",
        units: "lux",
        icon: LightIcon
    },
    // {
    //   name: "O₂",
    //   type: "O2",
    //   units: "%",
    //   icon: O2Icon
    // },
    // {
    //   name: "Soil Moisture",
    //   type: "soil-moisture",
    //   units: "",
    //   icon: MoistureIcon
    // },
    // {
    //   name: "Particulates",
    //   type: "particulates",
    //   units: "PM2.5",
    //   icon: ParticulatesIcon
    // },
    {
        name: "EMG",
        type: "emg-reading",
        units: "mV",
        icon: EMGIcon,
        decimalPlaces: 0
    },
    {
        name: "Surface Pressure",
        type: "fsr-reading",
        units: "psi",
        icon: PressureIcon,
        decimalPlaces: 0
    },
    {
        name: "Pin Reading",
        type: "pin-reading",
        units: "mV",
        icon: SignalIcon,
        decimalPlaces: 0
    }
];
export const NodeDemoOutputTypes = [
    {
        name: "Light Bulb",
        icon: LightBulbIcon
    },
    {
        name: "Grabber",
        icon: GrabberIcon,
        displayName: "Gripper"
    },
    {
        name: "Advanced Grabber",
        icon: AdvancedGrabberIcon,
        displayName: "Advanced Gripper"
    },
    {
        name: "Fan",
        icon: FanIcon
    },
    {
        name: "Humidifier",
        icon: HumidIcon
    }
];
export const NodeLiveOutputTypes = [
    {
        name: "Gripper 2.0",
        icon: GrabberIcon,
        angleBase: 130,
        sweep: 95
    },
    {
        name: "Grabber",
        icon: GrabberIcon,
        angleBase: 180,
        sweep: 60,
        displayName: "Gripper"
    },
    {
        name: "Humidifier",
        icon: HumidIcon,
        relayIndex: 2
    },
    {
        name: "Fan",
        icon: FanIcon,
        relayIndex: 1
    },
    {
        name: "Heat Lamp",
        icon: LightBulbIcon,
        relayIndex: 0
    },
    {
        name: "Servo",
        icon: ServoIcon,
        angleBase: 0,
        angleOffset: 30,
        angleScale: 2 / 3,
        sweep: 180
    }
];
function createNodeMicroBitHubs(arr) {
    return arr.map((id) => {
        return {
            id,
            name: `micro:bit hub ${id}`,
            active: false
        };
    });
}
const hubIdentifiers = ["a", "b", "c", "d", "e", "f", "g", "h"];
export const NodeMicroBitHubs = createNodeMicroBitHubs(hubIdentifiers);
export const NodeGeneratorTypes = [
    {
        name: "Sine",
        method: (t, p, a) => Math.round(Math.sin(t * Math.PI / (p / 2)) * a * 100) / 100,
        icon: SineIcon
    },
    {
        name: "Square",
        method: (t, p, a) => t % p < p / 2 ? 1 * a : 0,
        icon: SquareIcon
    },
    {
        name: "Triangle",
        method: (t, p, a) => (2 * a / p) * Math.abs(t % p - p / 2),
        icon: TriangleIcon
    }
];
export const baseLiveOutputOptions = {
    liveGripperOption: {
        active: true,
        icon: GrabberIcon,
        id: "bb-gripper",
        name: "Physical Gripper"
    },
    noDeviceLiveGripperOption: {
        active: true,
        id: "no-device-bb-gripper",
        name: "Physical Gripper",
        displayName: "⚠️ connect device",
    },
    liveServoOption: {
        active: true,
        icon: ServoIcon,
        id: "bb-servo",
        name: "Physical Servo"
    },
    noDeviceliveServoOption: {
        active: true,
        id: "no-devie-bb-servo",
        name: "Physical Servo",
        displayName: "⚠️ connect device",
    },
    genericWarningOption: {
        active: true,
        id: "no-outputs-found",
        name: "⚠️ connect device",
    }
};
// Given whether a device is connected and which one, decide how a live-output
// option should present: it drives the device, the connected device can't drive
// it, or no device is connected. See design spec §3.4.
export function outputGateState(connected, deviceFamily, category) {
    if (connected && deviceSupportsOutput(deviceFamily, category))
        return "live";
    if (connected)
        return "unsupported";
    return "no-device";
}
// A hubSelect option shown when a device IS connected but does not support the
// selected output category. `name` matches the live/no-device variants so the
// hubSelect value stays stable; `displayName` carries the warning.
export function unsupportedOutputOption(category, deviceDisplayName) {
    const nameByCategory = {
        gripper: "Physical Gripper",
        servo: "Physical Servo",
        relay: "⚠️ connect device",
    };
    const label = deviceDisplayName !== null && deviceDisplayName !== void 0 ? deviceDisplayName : "This device";
    return {
        active: true,
        id: `unsupported-${category}`,
        name: nameByCategory[category],
        displayName: `⚠️ ${label} doesn't support this output`,
    };
}
export const NodePeriodUnits = [
    {
        unit: "sec",
        lengthInSeconds: 1
    },
    {
        unit: "min",
        lengthInSeconds: 60
    },
    {
        unit: "hour",
        lengthInSeconds: 3600
    },
];
export const NodeTimerInfo = {
    method: (t, tOn, tOff) => t % (tOn + tOff) < tOn ? 1 : 0,
};
export const ChartPlotColors = ["#d51eff", "#17ddd7", "#d3d114", "#3974ff", "#ff3d3d",
    "#49d381", "#b05ecb", "#ffd56d", "#ffa56d", "#f57676",
    "#fa73b0", "#eb80dc", "#cd88e4", "#d49600", "#d45200",
    "#c60e0e", "#cc0860", "#b81da1", "#8d27ad", "#8b989f",
    "#5dd581", "#3cc8f5", "#aeb9bf", "#92e3aa", "#7ad9f8",
    "#5d6e77", "#31bc5a", "#0caadd"];
export const NodePlotColor = "#3f3f3f";
export const NodePlotBlue = ChartPlotColors[3];
export const NodePlotRed = ChartPlotColors[4];
export const DEFAULT_DATA_RATE = 1000;
export const ProgramDataRates = [
    {
        text: "50ms",
        val: 50
    },
    {
        text: "100ms",
        val: 100
    },
    {
        text: "500ms",
        val: 500
    },
    {
        text: "1 sec",
        val: 1000
    },
    {
        text: "10 sec",
        val: 10000
    },
    {
        text: "1 min",
        val: 60000
    }
];
export const kSensorSelectMessage = "Select an input";
export const kSensorMissingMessage = "⚠️";
export const kAnimatedBinaryTypes = ["Fan", "Humidifier"];
export const kMicroBitHubRelaysIndexed = ["Heat Lamp", "Fan", "Humidifier"];
export const kBinaryOutputTypes = [...kMicroBitHubRelaysIndexed, "Light Bulb"];
export const kGripperOutputTypes = ["Grabber", "Gripper", "Gripper 2.0"];
export const kServoOutputTypes = ["Servo"];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibm9kZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9wbHVnaW5zL2RhdGFmbG93L21vZGVsL3V0aWxpdGllcy9ub2RlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sUUFBUSxNQUFNLDBEQUEwRCxDQUFDO0FBQ2hGLE9BQU8sVUFBVSxNQUFNLDREQUE0RCxDQUFDO0FBQ3BGLE9BQU8sWUFBWSxNQUFNLDhEQUE4RCxDQUFDO0FBRXhGLE9BQU8sT0FBTyxNQUFNLHFEQUFxRCxDQUFDO0FBQzFFLE9BQU8sU0FBUyxNQUFNLHVEQUF1RCxDQUFDO0FBQzlFLE9BQU8sd0JBQXdCLE1BQU0sMEVBQTBFLENBQUM7QUFDaEgsT0FBTyxlQUFlLE1BQU0sOERBQThELENBQUM7QUFDM0YsT0FBTyxxQkFBcUIsTUFBTSx1RUFBdUUsQ0FBQztBQUMxRyxPQUFPLFlBQVksTUFBTSwyREFBMkQsQ0FBQztBQUNyRixPQUFPLFFBQVEsTUFBTSxzREFBc0QsQ0FBQztBQUM1RSxPQUFPLFlBQVksTUFBTSwyREFBMkQsQ0FBQztBQUNyRixPQUFPLE1BQU0sTUFBTSxvREFBb0QsQ0FBQztBQUN4RSxPQUFPLE9BQU8sTUFBTSxxREFBcUQsQ0FBQztBQUUxRSxPQUFPLE9BQU8sTUFBTSxvREFBb0QsQ0FBQztBQUN6RSxPQUFPLFlBQVksTUFBTSx5REFBeUQsQ0FBQztBQUNuRixPQUFPLFlBQVksTUFBTSx5REFBeUQsQ0FBQztBQUNuRixPQUFPLFVBQVUsTUFBTSx1REFBdUQsQ0FBQztBQUUvRSxPQUFPLGFBQWEsTUFBTSw2REFBNkQsQ0FBQztBQUN4RixPQUFPLFdBQVcsTUFBTSwwREFBMEQsQ0FBQztBQUNuRixPQUFPLG1CQUFtQixNQUFNLGdEQUFnRCxDQUFDO0FBQ2pGLE9BQU8sU0FBUyxNQUFNLHdEQUF3RCxDQUFDO0FBQy9FLE9BQU8sT0FBTyxNQUFNLHNEQUFzRCxDQUFDO0FBRTNFLE9BQU8sZUFBZSxNQUFNLDhEQUE4RCxDQUFDO0FBQzNGLE9BQU8sT0FBTyxNQUFNLHNEQUFzRCxDQUFDO0FBQzNFLE9BQU8sWUFBWSxNQUFNLDJEQUEyRCxDQUFDO0FBQ3JGLE9BQU8sU0FBUyxNQUFNLHdEQUF3RCxDQUFDO0FBQy9FLE9BQU8sVUFBVSxNQUFNLDBEQUEwRCxDQUFDO0FBQ2xGLE9BQU8sT0FBTyxNQUFNLGtFQUFrRSxDQUFDO0FBQ3ZGLE9BQU8sWUFBWSxNQUFNLDJEQUEyRCxDQUFDO0FBQ3JGLE9BQU8sU0FBUyxNQUFNLHdEQUF3RCxDQUFDO0FBRS9FLE9BQU8saUJBQWlCLE1BQU0sb0VBQW9FLENBQUM7QUFDbkcsT0FBTyxZQUFZLE1BQU0sOERBQThELENBQUM7QUFDeEYsT0FBTyxPQUFPLE1BQU0seURBQXlELENBQUM7QUFFOUUsT0FBTyxxQkFBcUIsTUFBTSw4Q0FBOEMsQ0FBQztBQUNqRixPQUFPLG9CQUFvQixNQUFNLDBDQUEwQyxDQUFDO0FBQzVFLE9BQU8saUJBQWlCLE1BQU0sMENBQTBDLENBQUM7QUFFekUsT0FBTyxFQUFFLGNBQWMsRUFBRSxNQUFNLGtDQUFrQyxDQUFDO0FBQ2xFLE9BQU8sRUFBRSxvQkFBb0IsRUFBa0IsTUFBTSx1QkFBdUIsQ0FBQztBQUU3RSxNQUFNLENBQUMsTUFBTSxjQUFjLEdBQUcsRUFBRSxDQUFDO0FBZ0JqQyxNQUFNLENBQUMsTUFBTSxTQUFTLEdBQWU7SUFDbkM7UUFDRSxJQUFJLEVBQUUsUUFBUTtRQUNkLFdBQVcsRUFBRSxPQUFPO0tBQ3JCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsUUFBUTtRQUNkLFdBQVcsRUFBRSxRQUFRO0tBQ3RCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsV0FBVztRQUNqQixXQUFXLEVBQUUsV0FBVztLQUN6QjtJQUNEO1FBQ0UsSUFBSSxFQUFFLE9BQU87UUFDYixXQUFXLEVBQUUsZ0JBQWdCO0tBQzlCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsTUFBTTtRQUNaLFdBQVcsRUFBRSxNQUFNO0tBQ3BCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsT0FBTztRQUNiLFdBQVcsRUFBRSxPQUFPO0tBQ3JCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsV0FBVztRQUNqQixXQUFXLEVBQUUsV0FBVztLQUN6QjtJQUNEO1FBQ0UsSUFBSSxFQUFFLFNBQVM7UUFDZixXQUFXLEVBQUUsTUFBTTtLQUNwQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLGFBQWE7UUFDbkIsV0FBVyxFQUFFLGFBQWE7S0FDM0I7SUFDRDtRQUNFLElBQUksRUFBRSxhQUFhO1FBQ25CLFdBQVcsRUFBRSxhQUFhO0tBQzNCO0NBQ0YsQ0FBQztBQUVGLE1BQU0sQ0FBQyxNQUFNLGtCQUFrQixHQUFHO0lBQ2hDO1FBQ0UsSUFBSSxFQUFFLEtBQUs7UUFDWCxJQUFJLEVBQUUsTUFBTTtRQUNaLE1BQU0sRUFBRSxDQUFDLEVBQVUsRUFBRSxFQUFVLEVBQUUsRUFBRSxDQUFDLEVBQUUsR0FBRyxFQUFFO1FBQzNDLGNBQWMsRUFBRSxDQUFDLEVBQVUsRUFBRSxFQUFVLEVBQUUsRUFBRSxDQUFDLEdBQUcsRUFBRSxNQUFNLEVBQUUsS0FBSztRQUM5RCxJQUFJLEVBQUUsT0FBTztLQUNkO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsVUFBVTtRQUNoQixJQUFJLEVBQUUsTUFBTTtRQUNaLE1BQU0sRUFBRSxDQUFDLEVBQVUsRUFBRSxFQUFVLEVBQUUsRUFBRSxDQUFDLEVBQUUsR0FBRyxFQUFFO1FBQzNDLGNBQWMsRUFBRSxDQUFDLEVBQVUsRUFBRSxFQUFVLEVBQUUsRUFBRSxDQUFDLEdBQUcsRUFBRSxNQUFNLEVBQUUsS0FBSztRQUM5RCxJQUFJLEVBQUUsWUFBWTtLQUNuQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLFVBQVU7UUFDaEIsSUFBSSxFQUFFLE1BQU07UUFDWixNQUFNLEVBQUUsQ0FBQyxFQUFVLEVBQUUsRUFBVSxFQUFFLEVBQUUsQ0FBQyxFQUFFLEdBQUcsRUFBRTtRQUMzQyxjQUFjLEVBQUUsQ0FBQyxFQUFVLEVBQUUsRUFBVSxFQUFFLEVBQUUsQ0FBQyxHQUFHLEVBQUUsTUFBTSxFQUFFLEtBQUs7UUFDOUQsSUFBSSxFQUFFLFlBQVk7S0FDbkI7SUFDRDtRQUNFLElBQUksRUFBRSxRQUFRO1FBQ2QsSUFBSSxFQUFFLE1BQU07UUFDWixNQUFNLEVBQUUsQ0FBQyxFQUFVLEVBQUUsRUFBVSxFQUFFLEVBQUUsQ0FBQyxFQUFFLEdBQUcsRUFBRTtRQUMzQyxjQUFjLEVBQUUsQ0FBQyxFQUFVLEVBQUUsRUFBVSxFQUFFLEVBQUUsQ0FBQyxHQUFHLEVBQUUsTUFBTSxFQUFFLEtBQUs7UUFDOUQsSUFBSSxFQUFFLFVBQVU7S0FDakI7SUFDRDtRQUNFLElBQUksRUFBRSxnQkFBZ0I7UUFDdEIsSUFBSSxFQUFFLFdBQVc7UUFDakIsTUFBTSxFQUFFLENBQUMsRUFBVSxFQUFFLEVBQVUsRUFBRSxFQUFFLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxFQUFFLENBQUM7UUFDaEQsY0FBYyxFQUFFLENBQUMsRUFBVSxFQUFFLEVBQVUsRUFBRSxFQUFFLENBQUMsSUFBSSxFQUFFLE1BQU07UUFDeEQsSUFBSSxFQUFFLGlCQUFpQjtLQUN4QjtJQUNEO1FBQ0UsSUFBSSxFQUFFLFVBQVU7UUFDaEIsSUFBSSxFQUFFLFdBQVc7UUFDakIsTUFBTSxFQUFFLENBQUMsRUFBVSxFQUFFLEVBQVUsRUFBRSxFQUFFLENBQUMsQ0FBQyxHQUFHLEVBQUU7UUFDMUMsY0FBYyxFQUFFLENBQUMsRUFBVSxFQUFFLEVBQVUsRUFBRSxFQUFFLENBQUMsS0FBSyxFQUFFLE1BQU07UUFDekQsSUFBSSxFQUFFLFlBQVk7S0FDbkI7SUFDRDtRQUNFLElBQUksRUFBRSxLQUFLO1FBQ1gsSUFBSSxFQUFFLFdBQVc7UUFDakIsTUFBTSxFQUFFLENBQUMsRUFBVSxFQUFFLEVBQVUsRUFBRSxFQUFFLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUM7UUFDOUMsY0FBYyxFQUFFLENBQUMsRUFBVSxFQUFFLEVBQVUsRUFBRSxFQUFFLENBQUMsSUFBSSxFQUFFLEtBQUs7UUFDdkQsSUFBSSxFQUFFLE9BQU87S0FDZDtJQUNEO1FBQ0UsSUFBSSxFQUFFLE9BQU87UUFDYixJQUFJLEVBQUUsV0FBVztRQUNqQixNQUFNLEVBQUUsQ0FBQyxFQUFVLEVBQUUsRUFBVSxFQUFFLEVBQUUsQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLEVBQUUsQ0FBQztRQUNsRCxjQUFjLEVBQUUsQ0FBQyxFQUFVLEVBQUUsRUFBVSxFQUFFLEVBQUUsQ0FBQyxTQUFTLEVBQUUsTUFBTTtRQUM3RCxJQUFJLEVBQUUsVUFBVTtLQUNqQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLE9BQU87UUFDYixJQUFJLEVBQUUsV0FBVztRQUNqQixNQUFNLEVBQUUsQ0FBQyxFQUFVLEVBQUUsRUFBVSxFQUFFLEVBQUUsQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLEVBQUUsQ0FBQztRQUNsRCxjQUFjLEVBQUUsQ0FBQyxFQUFVLEVBQUUsRUFBVSxFQUFFLEVBQUUsQ0FBQyxTQUFTLEVBQUUsTUFBTTtRQUM3RCxJQUFJLEVBQUUsVUFBVTtLQUNqQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLE1BQU07UUFDWixJQUFJLEVBQUUsV0FBVztRQUNqQixNQUFNLEVBQUUsQ0FBQyxFQUFVLEVBQUUsRUFBVSxFQUFFLEVBQUUsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQztRQUNqRCxjQUFjLEVBQUUsQ0FBQyxFQUFVLEVBQUUsRUFBVSxFQUFFLEVBQUUsQ0FBQyxRQUFRLEVBQUUsTUFBTTtRQUM1RCxJQUFJLEVBQUUsVUFBVTtLQUNqQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLE1BQU07UUFDWixJQUFJLEVBQUUsV0FBVztRQUNqQixNQUFNLEVBQUUsQ0FBQyxFQUFVLEVBQUUsRUFBVSxFQUFFLFNBQWtCLEVBQUUsRUFBRTtZQUNyRCxJQUFJLENBQUMsY0FBYyxDQUFDLFNBQVMsQ0FBQztnQkFBRSxPQUFPLEVBQUUsQ0FBQztZQUUxQyxNQUFNLEtBQUssR0FBRyxFQUFFLEdBQUcsU0FBUyxDQUFDO1lBQzdCLE1BQU0sT0FBTyxHQUFHLElBQUksQ0FBQyxHQUFHLENBQUMsS0FBSyxDQUFDLEdBQUcsR0FBRyxHQUFHLFNBQVMsQ0FBQztZQUVsRCxJQUFJLEtBQUssR0FBRyxDQUFDLEVBQUUsQ0FBQztnQkFDZCxNQUFNLFVBQVUsR0FBRyxFQUFFLEdBQUcsR0FBRyxDQUFDO2dCQUM1QixPQUFPLE9BQU8sQ0FBQyxDQUFDLENBQUMsU0FBUyxHQUFHLFVBQVUsQ0FBQyxDQUFDLENBQUMsRUFBRSxDQUFDO1lBQy9DLENBQUM7WUFFRCxJQUFJLEtBQUssR0FBRyxDQUFDLEVBQUUsQ0FBQztnQkFDZCxNQUFNLFVBQVUsR0FBRyxTQUFTLEdBQUcsR0FBRyxDQUFDO2dCQUNuQyxPQUFPLE9BQU8sQ0FBQyxDQUFDLENBQUMsU0FBUyxHQUFHLFVBQVUsQ0FBQyxDQUFDLENBQUMsRUFBRSxDQUFDO1lBQy9DLENBQUM7WUFFRCxPQUFPLEVBQUUsQ0FBQztRQUNaLENBQUM7UUFDRCxjQUFjLEVBQUUsQ0FBQyxFQUFVLEVBQUUsRUFBVSxFQUFFLEVBQUUsQ0FBQyxHQUFHLEVBQUUsS0FBSztRQUN0RCxJQUFJLEVBQUUsVUFBVTtLQUNqQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLGNBQWM7UUFDcEIsSUFBSSxFQUFFLE9BQU87UUFDYixNQUFNLEVBQUUsQ0FBQyxFQUFVLEVBQUUsRUFBVSxFQUFFLEVBQUUsQ0FBQyxDQUFDLENBQUMsRUFBRSxHQUFHLEVBQUUsQ0FBQztRQUM5QyxjQUFjLEVBQUUsQ0FBQyxFQUFVLEVBQUUsRUFBVSxFQUFFLEVBQUUsQ0FBQyxHQUFHLEVBQUUsTUFBTSxFQUFFLEtBQUs7UUFDOUQsSUFBSSxFQUFFLGVBQWU7S0FDdEI7SUFDRDtRQUNFLElBQUksRUFBRSxXQUFXO1FBQ2pCLElBQUksRUFBRSxPQUFPO1FBQ2IsTUFBTSxFQUFFLENBQUMsRUFBVSxFQUFFLEVBQVUsRUFBRSxFQUFFLENBQUMsQ0FBQyxDQUFDLEVBQUUsR0FBRyxFQUFFLENBQUM7UUFDOUMsY0FBYyxFQUFFLENBQUMsRUFBVSxFQUFFLEVBQVUsRUFBRSxFQUFFLENBQUMsR0FBRyxFQUFFLE1BQU0sRUFBRSxLQUFLO1FBQzlELElBQUksRUFBRSxZQUFZO0tBQ25CO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsMEJBQTBCO1FBQ2hDLElBQUksRUFBRSxPQUFPO1FBQ2IsTUFBTSxFQUFFLENBQUMsRUFBVSxFQUFFLEVBQVUsRUFBRSxFQUFFLENBQUMsQ0FBQyxDQUFDLEVBQUUsSUFBSSxFQUFFLENBQUM7UUFDL0MsY0FBYyxFQUFFLENBQUMsRUFBVSxFQUFFLEVBQVUsRUFBRSxFQUFFLENBQUMsR0FBRyxFQUFFLE9BQU8sRUFBRSxLQUFLO1FBQy9ELElBQUksRUFBRSx3QkFBd0I7S0FDL0I7SUFDRDtRQUNFLElBQUksRUFBRSx1QkFBdUI7UUFDN0IsSUFBSSxFQUFFLE9BQU87UUFDYixNQUFNLEVBQUUsQ0FBQyxFQUFVLEVBQUUsRUFBVSxFQUFFLEVBQUUsQ0FBQyxDQUFDLENBQUMsRUFBRSxJQUFJLEVBQUUsQ0FBQztRQUMvQyxjQUFjLEVBQUUsQ0FBQyxFQUFVLEVBQUUsRUFBVSxFQUFFLEVBQUUsQ0FBQyxHQUFHLEVBQUUsT0FBTyxFQUFFLEtBQUs7UUFDL0QsSUFBSSxFQUFFLHFCQUFxQjtLQUM1QjtJQUNEO1FBQ0UsSUFBSSxFQUFFLE9BQU87UUFDYixJQUFJLEVBQUUsT0FBTztRQUNiLE1BQU0sRUFBRSxDQUFDLEVBQVUsRUFBRSxFQUFVLEVBQUUsRUFBRSxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxDQUFDO1FBQ2hELGNBQWMsRUFBRSxDQUFDLEVBQVUsRUFBRSxFQUFVLEVBQUUsRUFBRSxDQUFDLEdBQUcsRUFBRSxPQUFPLEVBQUUsS0FBSztRQUMvRCxJQUFJLEVBQUUsU0FBUztLQUNoQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLFdBQVc7UUFDakIsSUFBSSxFQUFFLE9BQU87UUFDYixNQUFNLEVBQUUsQ0FBQyxFQUFVLEVBQUUsRUFBVSxFQUFFLEVBQUUsQ0FBQyxDQUFDLENBQUMsRUFBRSxLQUFLLEVBQUUsQ0FBQztRQUNoRCxjQUFjLEVBQUUsQ0FBQyxFQUFVLEVBQUUsRUFBVSxFQUFFLEVBQUUsQ0FBQyxHQUFHLEVBQUUsT0FBTyxFQUFFLEtBQUs7UUFDL0QsSUFBSSxFQUFFLFlBQVk7S0FDbkI7SUFDRDtRQUNFLElBQUksRUFBRSxLQUFLO1FBQ1gsSUFBSSxFQUFFLE9BQU87UUFDYixNQUFNLEVBQUUsQ0FBQyxFQUFVLEVBQUUsRUFBVSxFQUFFLEVBQUUsQ0FBQyxFQUFFLElBQUksRUFBRSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUM7UUFDcEQsY0FBYyxFQUFFLENBQUMsRUFBVSxFQUFFLEVBQVUsRUFBRSxFQUFFLENBQUMsR0FBRyxFQUFFLE9BQU8sRUFBRSxLQUFLO1FBQy9ELElBQUksRUFBRSxPQUFPO0tBQ2Q7SUFDRDtRQUNFLElBQUksRUFBRSxJQUFJO1FBQ1YsSUFBSSxFQUFFLE9BQU87UUFDYixNQUFNLEVBQUUsQ0FBQyxFQUFVLEVBQUUsRUFBVSxFQUFFLEVBQUUsQ0FBQyxFQUFFLElBQUksRUFBRSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUM7UUFDcEQsY0FBYyxFQUFFLENBQUMsRUFBVSxFQUFFLEVBQVUsRUFBRSxFQUFFLENBQUMsR0FBRyxFQUFFLE9BQU8sRUFBRSxLQUFLO1FBQy9ELElBQUksRUFBRSxNQUFNO0tBQ2I7SUFDRDtRQUNFLElBQUksRUFBRSxNQUFNO1FBQ1osSUFBSSxFQUFFLE9BQU87UUFDYixNQUFNLEVBQUUsQ0FBQyxFQUFVLEVBQUUsRUFBVSxFQUFFLEVBQUUsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLEVBQUUsSUFBSSxFQUFFLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUM7UUFDMUQsY0FBYyxFQUFFLENBQUMsRUFBVSxFQUFFLEVBQVUsRUFBRSxFQUFFLENBQUMsR0FBRyxFQUFFLFNBQVMsRUFBRSxLQUFLO1FBQ2pFLElBQUksRUFBRSxRQUFRO0tBQ2Y7SUFDRDtRQUNFLElBQUksRUFBRSxLQUFLO1FBQ1gsSUFBSSxFQUFFLE9BQU87UUFDYixNQUFNLEVBQUUsQ0FBQyxFQUFVLEVBQUUsRUFBVSxFQUFFLEVBQUUsQ0FBQyxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUM7UUFDcEUsY0FBYyxFQUFFLENBQUMsRUFBVSxFQUFFLEVBQVUsRUFBRSxFQUFFLENBQUMsR0FBRyxFQUFFLFFBQVEsRUFBRSxLQUFLO1FBQ2hFLElBQUksRUFBRSxPQUFPO0tBQ2Q7Q0FDRixDQUFDO0FBRUYsTUFBTSxDQUFDLE1BQU0sbUJBQW1CLEdBQUc7SUFDakM7UUFDRSxJQUFJLEVBQUUsY0FBYztRQUNwQixXQUFXLEVBQUUsV0FBVztRQUN4QixJQUFJLEVBQUUsU0FBUztRQUNmLElBQUksRUFBRSxvQkFBb0I7S0FDM0I7SUFDRDtRQUNFLElBQUksRUFBRSxZQUFZO1FBQ2xCLFdBQVcsRUFBRSxlQUFlO1FBQzVCLElBQUksRUFBRSxTQUFTO1FBQ2YsSUFBSSxFQUFFLHFCQUFxQjtLQUM1QjtJQUNEO1FBQ0UsSUFBSSxFQUFFLGFBQWE7UUFDbkIsV0FBVyxFQUFFLFFBQVE7UUFDckIsSUFBSSxFQUFFLFNBQVM7UUFDZixJQUFJLEVBQUUsaUJBQWlCO0tBQ3hCO0lBQ0QsSUFBSTtJQUNKLCtCQUErQjtJQUMvQixvQ0FBb0M7SUFDcEMscUJBQXFCO0lBQ3JCLCtCQUErQjtJQUMvQixLQUFLO0lBQ0wsSUFBSTtJQUNKLDZCQUE2QjtJQUM3Qix3Q0FBd0M7SUFDeEMscUJBQXFCO0lBQ3JCLGdDQUFnQztJQUNoQyxLQUFLO0lBQ0wsSUFBSTtJQUNKLDhCQUE4QjtJQUM5QixpQ0FBaUM7SUFDakMscUJBQXFCO0lBQ3JCLDRCQUE0QjtJQUM1QixJQUFJO0NBQ0wsQ0FBQztBQUVGLE1BQU0sQ0FBQyxNQUFNLGVBQWUsR0FBRztJQUM3QjtRQUNFLElBQUksRUFBRSxhQUFhO1FBQ25CLElBQUksRUFBRSxhQUFhO1FBQ25CLEtBQUssRUFBRSxJQUFJO1FBQ1gsSUFBSSxFQUFFLGVBQWU7S0FDdEI7SUFDRDtRQUNFLElBQUksRUFBRSxVQUFVO1FBQ2hCLElBQUksRUFBRSxVQUFVO1FBQ2hCLEtBQUssRUFBRSxHQUFHO1FBQ1YsSUFBSSxFQUFFLFlBQVk7S0FDbkI7SUFDRDtRQUNFLElBQUksRUFBRSxLQUFLO1FBQ1gsSUFBSSxFQUFFLEtBQUs7UUFDWCxLQUFLLEVBQUUsS0FBSztRQUNaLElBQUksRUFBRSxPQUFPO0tBQ2Q7SUFDRDtRQUNFLElBQUksRUFBRSxPQUFPO1FBQ2IsSUFBSSxFQUFFLE9BQU87UUFDYixLQUFLLEVBQUUsS0FBSztRQUNaLElBQUksRUFBRSxTQUFTO0tBQ2hCO0lBQ0QsSUFBSTtJQUNKLGdCQUFnQjtJQUNoQixnQkFBZ0I7SUFDaEIsZ0JBQWdCO0lBQ2hCLGlCQUFpQjtJQUNqQixLQUFLO0lBQ0wsSUFBSTtJQUNKLDJCQUEyQjtJQUMzQiwyQkFBMkI7SUFDM0IsZUFBZTtJQUNmLHVCQUF1QjtJQUN2QixLQUFLO0lBQ0wsSUFBSTtJQUNKLDBCQUEwQjtJQUMxQiwwQkFBMEI7SUFDMUIsb0JBQW9CO0lBQ3BCLDJCQUEyQjtJQUMzQixLQUFLO0lBQ0w7UUFDRSxJQUFJLEVBQUUsS0FBSztRQUNYLElBQUksRUFBRSxhQUFhO1FBQ25CLEtBQUssRUFBRSxJQUFJO1FBQ1gsSUFBSSxFQUFFLE9BQU87UUFDYixhQUFhLEVBQUUsQ0FBQztLQUNqQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLGtCQUFrQjtRQUN4QixJQUFJLEVBQUUsYUFBYTtRQUNuQixLQUFLLEVBQUUsS0FBSztRQUNaLElBQUksRUFBRSxZQUFZO1FBQ2xCLGFBQWEsRUFBRSxDQUFDO0tBQ2pCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsYUFBYTtRQUNuQixJQUFJLEVBQUUsYUFBYTtRQUNuQixLQUFLLEVBQUUsSUFBSTtRQUNYLElBQUksRUFBRSxVQUFVO1FBQ2hCLGFBQWEsRUFBRSxDQUFDO0tBQ2pCO0NBQ0YsQ0FBQztBQUVGLE1BQU0sQ0FBQyxNQUFNLG1CQUFtQixHQUFHO0lBQ2pDO1FBQ0UsSUFBSSxFQUFFLFlBQVk7UUFDbEIsSUFBSSxFQUFFLGFBQWE7S0FDcEI7SUFDRDtRQUNFLElBQUksRUFBRSxTQUFTO1FBQ2YsSUFBSSxFQUFFLFdBQVc7UUFDakIsV0FBVyxFQUFFLFNBQVM7S0FDdkI7SUFDRDtRQUNFLElBQUksRUFBRSxrQkFBa0I7UUFDeEIsSUFBSSxFQUFFLG1CQUFtQjtRQUN6QixXQUFXLEVBQUUsa0JBQWtCO0tBQ2hDO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsS0FBSztRQUNYLElBQUksRUFBRSxPQUFPO0tBQ2Q7SUFDRDtRQUNFLElBQUksRUFBRSxZQUFZO1FBQ2xCLElBQUksRUFBRSxTQUFTO0tBQ2hCO0NBQ08sQ0FBQztBQUdYLE1BQU0sQ0FBQyxNQUFNLG1CQUFtQixHQUFHO0lBQ2pDO1FBQ0UsSUFBSSxFQUFFLGFBQWE7UUFDbkIsSUFBSSxFQUFFLFdBQVc7UUFDakIsU0FBUyxFQUFFLEdBQUc7UUFDZCxLQUFLLEVBQUUsRUFBRTtLQUNWO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsU0FBUztRQUNmLElBQUksRUFBRSxXQUFXO1FBQ2pCLFNBQVMsRUFBRSxHQUFHO1FBQ2QsS0FBSyxFQUFFLEVBQUU7UUFDVCxXQUFXLEVBQUUsU0FBUztLQUN2QjtJQUNEO1FBQ0UsSUFBSSxFQUFFLFlBQVk7UUFDbEIsSUFBSSxFQUFFLFNBQVM7UUFDZixVQUFVLEVBQUUsQ0FBQztLQUNkO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsS0FBSztRQUNYLElBQUksRUFBRSxPQUFPO1FBQ2IsVUFBVSxFQUFFLENBQUM7S0FDZDtJQUNEO1FBQ0UsSUFBSSxFQUFFLFdBQVc7UUFDakIsSUFBSSxFQUFFLGFBQWE7UUFDbkIsVUFBVSxFQUFFLENBQUM7S0FDZDtJQUNEO1FBQ0UsSUFBSSxFQUFFLE9BQU87UUFDYixJQUFJLEVBQUUsU0FBUztRQUNmLFNBQVMsRUFBRSxDQUFDO1FBQ1osV0FBVyxFQUFFLEVBQUU7UUFDZixVQUFVLEVBQUUsQ0FBQyxHQUFHLENBQUM7UUFDakIsS0FBSyxFQUFFLEdBQUc7S0FDWDtDQUNGLENBQUM7QUFFRixTQUFTLHNCQUFzQixDQUFDLEdBQWE7SUFDM0MsT0FBTyxHQUFHLENBQUMsR0FBRyxDQUFDLENBQUMsRUFBRSxFQUFFLEVBQUU7UUFDcEIsT0FBTztZQUNMLEVBQUU7WUFDRixJQUFJLEVBQUUsaUJBQWlCLEVBQUUsRUFBRTtZQUMzQixNQUFNLEVBQUUsS0FBSztTQUNkLENBQUM7SUFDSixDQUFDLENBQUMsQ0FBQztBQUNMLENBQUM7QUFDRCxNQUFNLGNBQWMsR0FBRyxDQUFDLEdBQUcsRUFBRSxHQUFHLEVBQUUsR0FBRyxFQUFFLEdBQUcsRUFBRSxHQUFHLEVBQUUsR0FBRyxFQUFFLEdBQUcsRUFBRSxHQUFHLENBQUMsQ0FBQztBQUNoRSxNQUFNLENBQUMsTUFBTSxnQkFBZ0IsR0FBRyxzQkFBc0IsQ0FBQyxjQUFjLENBQUMsQ0FBQztBQUV2RSxNQUFNLENBQUMsTUFBTSxrQkFBa0IsR0FBRztJQUNoQztRQUNFLElBQUksRUFBRSxNQUFNO1FBQ1osTUFBTSxFQUFFLENBQUMsQ0FBUyxFQUFFLENBQVMsRUFBRSxDQUFTLEVBQUUsRUFBRSxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFDLEdBQUcsSUFBSSxDQUFDLEVBQUUsR0FBRyxDQUFDLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxHQUFHLENBQUMsR0FBRyxHQUFHLENBQUMsR0FBRyxHQUFHO1FBQ3hHLElBQUksRUFBRSxRQUFRO0tBQ2Y7SUFDRDtRQUNFLElBQUksRUFBRSxRQUFRO1FBQ2QsTUFBTSxFQUFFLENBQUMsQ0FBUyxFQUFFLENBQVMsRUFBRSxDQUFTLEVBQUUsRUFBRSxDQUFDLENBQUMsR0FBRyxDQUFDLEdBQUcsQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQztRQUN0RSxJQUFJLEVBQUUsVUFBVTtLQUNqQjtJQUNEO1FBQ0UsSUFBSSxFQUFFLFVBQVU7UUFDaEIsTUFBTSxFQUFFLENBQUMsQ0FBUyxFQUFFLENBQVMsRUFBRSxDQUFTLEVBQUUsRUFBRSxDQUFDLENBQUMsQ0FBQyxHQUFHLENBQUMsR0FBRyxDQUFDLENBQUMsR0FBRyxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUMsR0FBRyxDQUFDLEdBQUcsQ0FBQyxHQUFHLENBQUMsQ0FBQztRQUNsRixJQUFJLEVBQUUsWUFBWTtLQUNuQjtDQUNGLENBQUM7QUFFRixNQUFNLENBQUMsTUFBTSxxQkFBcUIsR0FBRztJQUNuQyxpQkFBaUIsRUFBRTtRQUNqQixNQUFNLEVBQUUsSUFBSTtRQUNaLElBQUksRUFBRSxXQUFXO1FBQ2pCLEVBQUUsRUFBRSxZQUFZO1FBQ2hCLElBQUksRUFBRSxrQkFBa0I7S0FDekI7SUFDRCx5QkFBeUIsRUFBRTtRQUN6QixNQUFNLEVBQUUsSUFBSTtRQUNaLEVBQUUsRUFBRSxzQkFBc0I7UUFDMUIsSUFBSSxFQUFFLGtCQUFrQjtRQUN4QixXQUFXLEVBQUUsbUJBQW1CO0tBQ2pDO0lBQ0QsZUFBZSxFQUFFO1FBQ2YsTUFBTSxFQUFFLElBQUk7UUFDWixJQUFJLEVBQUUsU0FBUztRQUNmLEVBQUUsRUFBRSxVQUFVO1FBQ2QsSUFBSSxFQUFFLGdCQUFnQjtLQUN2QjtJQUNELHVCQUF1QixFQUFFO1FBQ3ZCLE1BQU0sRUFBRSxJQUFJO1FBQ1osRUFBRSxFQUFFLG1CQUFtQjtRQUN2QixJQUFJLEVBQUUsZ0JBQWdCO1FBQ3RCLFdBQVcsRUFBRSxtQkFBbUI7S0FDakM7SUFDRCxvQkFBb0IsRUFBRTtRQUNwQixNQUFNLEVBQUUsSUFBSTtRQUNaLEVBQUUsRUFBRSxrQkFBa0I7UUFDdEIsSUFBSSxFQUFFLG1CQUFtQjtLQUMxQjtDQUNGLENBQUM7QUFJRiw4RUFBOEU7QUFDOUUsZ0ZBQWdGO0FBQ2hGLHVEQUF1RDtBQUN2RCxNQUFNLFVBQVUsZUFBZSxDQUM3QixTQUFrQixFQUFFLFlBQWdDLEVBQUUsUUFBd0I7SUFFOUUsSUFBSSxTQUFTLElBQUksb0JBQW9CLENBQUMsWUFBWSxFQUFFLFFBQVEsQ0FBQztRQUFFLE9BQU8sTUFBTSxDQUFDO0lBQzdFLElBQUksU0FBUztRQUFFLE9BQU8sYUFBYSxDQUFDO0lBQ3BDLE9BQU8sV0FBVyxDQUFDO0FBQ3JCLENBQUM7QUFFRCwrRUFBK0U7QUFDL0UsOEVBQThFO0FBQzlFLG1FQUFtRTtBQUNuRSxNQUFNLFVBQVUsdUJBQXVCLENBQUMsUUFBd0IsRUFBRSxpQkFBMEI7SUFDMUYsTUFBTSxjQUFjLEdBQW1DO1FBQ3JELE9BQU8sRUFBRSxrQkFBa0I7UUFDM0IsS0FBSyxFQUFFLGdCQUFnQjtRQUN2QixLQUFLLEVBQUUsbUJBQW1CO0tBQzNCLENBQUM7SUFDRixNQUFNLEtBQUssR0FBRyxpQkFBaUIsYUFBakIsaUJBQWlCLGNBQWpCLGlCQUFpQixHQUFJLGFBQWEsQ0FBQztJQUNqRCxPQUFPO1FBQ0wsTUFBTSxFQUFFLElBQUk7UUFDWixFQUFFLEVBQUUsZUFBZSxRQUFRLEVBQUU7UUFDN0IsSUFBSSxFQUFFLGNBQWMsQ0FBQyxRQUFRLENBQUM7UUFDOUIsV0FBVyxFQUFFLE1BQU0sS0FBSyw4QkFBOEI7S0FDdkQsQ0FBQztBQUNKLENBQUM7QUFFRCxNQUFNLENBQUMsTUFBTSxlQUFlLEdBQUc7SUFDN0I7UUFDRSxJQUFJLEVBQUUsS0FBSztRQUNYLGVBQWUsRUFBRSxDQUFDO0tBQ25CO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsS0FBSztRQUNYLGVBQWUsRUFBRSxFQUFFO0tBQ3BCO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsTUFBTTtRQUNaLGVBQWUsRUFBRSxJQUFJO0tBQ3RCO0NBQ0YsQ0FBQztBQUVGLE1BQU0sQ0FBQyxNQUFNLGFBQWEsR0FDMUI7SUFDRSxNQUFNLEVBQUUsQ0FBQyxDQUFTLEVBQUUsR0FBVyxFQUFFLElBQVksRUFBRSxFQUFFLENBQUMsQ0FBQyxHQUFHLENBQUMsR0FBRyxHQUFHLElBQUksQ0FBQyxHQUFHLEdBQUcsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDO0NBQ2pGLENBQUM7QUFFRixNQUFNLENBQUMsTUFBTSxlQUFlLEdBQUcsQ0FBQyxTQUFTLEVBQUUsU0FBUyxFQUFFLFNBQVMsRUFBRSxTQUFTLEVBQUUsU0FBUztJQUN0RCxTQUFTLEVBQUUsU0FBUyxFQUFFLFNBQVMsRUFBRSxTQUFTLEVBQUUsU0FBUztJQUNyRCxTQUFTLEVBQUUsU0FBUyxFQUFFLFNBQVMsRUFBRSxTQUFTLEVBQUUsU0FBUztJQUNyRCxTQUFTLEVBQUUsU0FBUyxFQUFFLFNBQVMsRUFBRSxTQUFTLEVBQUUsU0FBUztJQUNyRCxTQUFTLEVBQUUsU0FBUyxFQUFFLFNBQVMsRUFBRSxTQUFTLEVBQUUsU0FBUztJQUNyRCxTQUFTLEVBQUUsU0FBUyxFQUFFLFNBQVMsQ0FBQyxDQUFDO0FBQ2hFLE1BQU0sQ0FBQyxNQUFNLGFBQWEsR0FBRyxTQUFTLENBQUM7QUFDdkMsTUFBTSxDQUFDLE1BQU0sWUFBWSxHQUFHLGVBQWUsQ0FBQyxDQUFDLENBQUMsQ0FBQztBQUMvQyxNQUFNLENBQUMsTUFBTSxXQUFXLEdBQUcsZUFBZSxDQUFDLENBQUMsQ0FBQyxDQUFDO0FBTzlDLE1BQU0sQ0FBQyxNQUFNLGlCQUFpQixHQUFHLElBQUksQ0FBQztBQUN0QyxNQUFNLENBQUMsTUFBTSxnQkFBZ0IsR0FBc0I7SUFDakQ7UUFDRSxJQUFJLEVBQUUsTUFBTTtRQUNaLEdBQUcsRUFBRSxFQUFFO0tBQ1I7SUFDRDtRQUNFLElBQUksRUFBRSxPQUFPO1FBQ2IsR0FBRyxFQUFFLEdBQUc7S0FDVDtJQUNEO1FBQ0UsSUFBSSxFQUFFLE9BQU87UUFDYixHQUFHLEVBQUUsR0FBRztLQUNUO0lBQ0Q7UUFDRSxJQUFJLEVBQUUsT0FBTztRQUNiLEdBQUcsRUFBRSxJQUFJO0tBQ1Y7SUFDRDtRQUNFLElBQUksRUFBRSxRQUFRO1FBQ2QsR0FBRyxFQUFFLEtBQUs7S0FDWDtJQUNEO1FBQ0UsSUFBSSxFQUFFLE9BQU87UUFDYixHQUFHLEVBQUUsS0FBSztLQUNYO0NBQ0YsQ0FBQztBQUVGLE1BQU0sQ0FBQyxNQUFNLG9CQUFvQixHQUFHLGlCQUFpQixDQUFDO0FBQ3RELE1BQU0sQ0FBQyxNQUFNLHFCQUFxQixHQUFHLElBQUksQ0FBQztBQUMxQyxNQUFNLENBQUMsTUFBTSxvQkFBb0IsR0FBRyxDQUFDLEtBQUssRUFBRSxZQUFZLENBQUMsQ0FBQztBQUMxRCxNQUFNLENBQUMsTUFBTSx5QkFBeUIsR0FBSSxDQUFDLFdBQVcsRUFBRSxLQUFLLEVBQUUsWUFBWSxDQUFDLENBQUM7QUFDN0UsTUFBTSxDQUFDLE1BQU0sa0JBQWtCLEdBQUcsQ0FBQyxHQUFHLHlCQUF5QixFQUFFLFlBQVksQ0FBQyxDQUFDO0FBQy9FLE1BQU0sQ0FBQyxNQUFNLG1CQUFtQixHQUFHLENBQUMsU0FBUyxFQUFFLFNBQVMsRUFBRSxhQUFhLENBQUMsQ0FBQztBQUN6RSxNQUFNLENBQUMsTUFBTSxpQkFBaUIsR0FBRyxDQUFDLE9BQU8sQ0FBQyxDQUFDIn0=